import { SanityClient } from '@sanity/client'

import { getShopItemsGroq } from '~/shared/sanity/groq/gem-shop'
import { GemShopInventory } from '~/types/gem-shop'
import { AppLanguage } from '~/types/locale'

import sanityClient from './sanity-client'

class GemShopSanity {
  private client: SanityClient

  public constructor() {
    this.client = sanityClient
  }

  public getGemShopItems(language: AppLanguage, evolution: null | string): Promise<GemShopInventory> {
    return this.client.fetch(getShopItemsGroq, { language, evolution })
  }
}

export const gemShopSanity = new GemShopSanity()
